const title = '名气家智能RPA助手'

const flowUIUrl = 'http://localhost:7081'

const config = {
  development: {
    baseUrl: 'http://localhost:8091/rpa-admin'
  },
  production: {
    baseUrl: 'https://ek.tunghuo.com/rpa-admin'
  },
  s: {
    baseUrl: 'http://s4.zcondigit.com:7788/admin'
  }
}
const env = process.env

const baseUrl = config[env.NODE_ENV].baseUrl
const flowUrl = baseUrl + '/flow/process/diagram-view?processInstanceId='

const aliOss = {
  region: 'oss-cn-shanghai',
  endpoint: 'oss-cn-shanghai.aliyuncs.com',
  accessKeyId: 'LTAIFkVdXgr3ryiG',
  accessKeySecret: 'jBTEHwGvwdDmHxjbKcSWHSkpxp82Th',
  bucket: 'good-flow'
}

export {
  aliOss,
  flowUIUrl,
  flowUrl,
  title,
  baseUrl
}
